import React, { useMemo, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import { formFields, screenInfo } from "./CopyBenefitMaxScheduleConfig";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";

const CopyBenefitMaxSchedule = ({ mode }) => {
  const location = useLocation();

  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  const {
    selectedPriceSchedules = [],
    previousScreen = ROUTE_PATHS.BENEFIT_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = currentState;
  // const { selectedPriceSchedules = [{ bscScheduleName: "SCHED1", bscDescription: "Description 1" }, { bscScheduleName: "SCHED2", bscDescription: "Description 2" }], previousScreen = '/out-of-pocket-schedule', currentIndex: initialIndex = 0 } = location.state || {};
  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  //   const [initialFormData, setInitialFormData] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();
  const { axios_helper_no_header } = useAxios();
  const initialFormData = useMemo(() => {
    const {
      bscScheduleName: parDscScheduleName = "",
      bscDescription: parDscDescription = "",
    } = selectedPriceSchedules[currentIndex];
    return {
      parDscScheduleName,
      parDscDescription,
      dtlDscScheduleName: "",
      dtlDscDescription: "",
    };
  }, [selectedPriceSchedules, currentIndex]);

  const lastValidOpcScheduleName = useRef("");

  const handleBack = () => {
    const lastScheduleName =
      selectedPriceSchedules[currentIndex]?.dtlDscScheduleName;
    if (lastScheduleName) {
      lastValidOpcScheduleName.current = lastScheduleName;
    }
    /* const updatedParamsData = {
      ...currentState.paramsData,
      bscScheduleName: lastValidOpcScheduleName.current,
    };*/

    if (currentIndex < selectedPriceSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      const lastRecord = previousState.pop() ?? {};
      const updatedLastRecord = lastValidOpcScheduleName.current
        ? {
            ...lastRecord,
            paramsData: {
              bscScheduleName: lastValidOpcScheduleName.current,
              hiddenRecordIndicator: "Active",
            },
          }
        : lastRecord;
      const updatedPreviousState = [...previousState, updatedLastRecord];
      navigateToPage(previousScreen, updatedPreviousState);
    }
  };

  const getPageTitle = () => {
    const { SCREEN_TITLE, SCREEN_NUMBER } = screenInfo;
    return (
      <>
        <span className="title">{SCREEN_TITLE}</span>
        <span>{"-"}</span>
        <span className="screen-number">{SCREEN_NUMBER}</span>
      </>
    );
  };

  const submitForm = async (dataForSubmission) => {
    const data = {
      ...dataForSubmission,
      screenNumber: screenInfo.SCREEN_NUMBER,
    };
    const url = "api/bscBenefitSchCtrl/copy";
    const verb = "POST";

    try {
      const { responseStatus } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
      selectedPriceSchedules[currentIndex].dtlDscScheduleName =
        data.dtlDscScheduleName;
      selectedPriceSchedules[currentIndex].dtlDscDescription =
        data.dtlDscDescription;
    } catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keys = [{ key: "F12", name: "Back", func: handleBack }];

    const keyFunc = {};
    const keyName = {};

    keys.forEach(({ key, name, func }) => {
      keyFunc[key] = func;
      keyName[key] = name;
    });

    return [keyFunc, keyName];
  }, [currentIndex]);

  //   useEffect(() => {
  //     const fetchInitialData = async () => {
  //       const url = `api/priceschedule/${selectedPriceSchedules[currentIndex]}`;
  //       try {
  //         const { responseData } = await axios_helper_no_header('GET', url, null, null);
  //         setInitialFormData(responseData);
  //       } catch (error) {
  //         const { responseStatus: { message } } = error.data;
  //         toast.current.show({ severity: "error", summary: "", detail: message, life: 3000 });
  //       }
  //     };

  //     fetchInitialData();
  //   }, [currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={mode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
        />
      </div>
    </div>
  );
};

export default CopyBenefitMaxSchedule;
